import request from '@/utils/request'

export const getAppId = (params={}) => {
    return request.get(`/feishu/getAppId`, params)
}
export const getToken=(params={})=>{
    return request.get(`/feishu/getToken/${params}`)
}

export const getUserInfo=(params={})=>{
    return request.get(`/feishu/getUserInfo`, params);
}
export const getLoginUserInfo=(params={})=>{
    return request.get(`/login/getUserInfo`, params);
}
